import { MessageCircle } from "lucide-react";

export const WhatsAppFab = () => {
  const number = process.env.REACT_APP_WHATSAPP_NUMBER || "";
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    "Hello Globus Financial Services, I would like to discuss my business funding requirement."
  )}`;
  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Globus Financial Services on WhatsApp"
      className="animate-fab-pulse fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-globus-navy text-white shadow-xl transition-transform duration-200 hover:scale-105"
    >
      <MessageCircle className="h-7 w-7 text-globus-tealLight" strokeWidth={2.2} />
    </a>
  );
};
